import { gql } from "generated-graphql";

/**
 * The totals describe the whole period, never the filtered page: narrowing to
 * one store answers "which ones", not "what is my adherence". Asking for them
 * on the period alone is what keeps that true, and it means the tiles hold
 * still while the reader filters and pages.
 */
export const WASTE_SCHEDULE_ADHERENCE_SUMMARY_QUERY = gql(`
  query WasteScheduleAdherenceSummary(
    $tenantId: ID!
    $from: Date!
    $through: Date!
  ) {
    wasteScheduleAdherence(
      tenantId: $tenantId
      from: $from
      through: $through
      pageSize: 1
    ) {
      calculatedAt
      summary {
        scheduledWindows
        windowsServed
        visitsOutsideWindow
        unscheduledVisits
        windowsWithNoService
        rowsNeedingReview
        withinSchedulePercent
      }
    }
  }
`);

export const WASTE_SCHEDULE_ADHERENCE_QUERY = gql(`
  query WasteScheduleAdherence(
    $tenantId: ID!
    $from: Date!
    $through: Date!
    $search: String
    $sort: [SortModel!]
    $page: Int
    $pageSize: Int
  ) {
    wasteScheduleAdherence(
      tenantId: $tenantId
      from: $from
      through: $through
      search: $search
      sort: $sort
      page: $page
      pageSize: $pageSize
    ) {
      count
      items {
        vendor
        status
        facilityId
        facilityName
        customerFacilityId
        kind
        daysOutside
        explanation
        issues {
          code
          message
          clarification
        }
        occurrence {
          id
          vendorServiceOrderNumber
          kind
          serviceType
          facilityId
          customerFacilityId
          scheduledWindowStart
          scheduledWindowEnd
        }
        candidates {
          id
          vendorServiceOrderNumber
          scheduledWindowStart
          scheduledWindowEnd
        }
        visit {
          serviceDate
          billedAmount
          serviceOrderNumber
          manifestNumber
          invoiceIds
          invoiceNumbers
          invoiceLines {
            id
            description
            kind
            code
            serviceKind
            sourceServiceType
            serviceSump
            serviceDate
            billedAmount
          }
        }
      }
    }
  }
`);
